const SUPPORTED_DOCUMENT_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

export const normalizeDocumentsResponse = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload?.data)) return payload.data;
  return Array.isArray(payload) ? payload : [];
};

export const isSupportedDocumentType = (mimeType) =>
  SUPPORTED_DOCUMENT_TYPES.has(mimeType);

/**
 * The Docs panel lists only PDFs and images; the other files of the same storage
 * (DICOM, EEG, 3D, Word…) are reached through the file explorer.
 */
export const isPdfOrImageDocument = (item) => {
  const fileType = String(item?.file_type ?? "");
  const mime = String(item?.mime ?? "");
  return (
    fileType.includes("pdf") || item?.type === "pdf" || mime.includes("pdf") ||
    fileType.startsWith("image/") || item?.type === "image" || mime.startsWith("image/")
  );
};

const hashString = (value) => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
};

export const createAnnotationStorageKey = (imageUrl) =>
  `ann:${imageUrl ? `src-${hashString(imageUrl)}` : "tmp"}`;

export const calculateZoomTransform = ({
  cursorX,
  cursorY,
  scale,
  translateX,
  translateY,
  deltaY,
  minScale = 0.4,
  maxScale = 5,
  step = 0.12,
}) => {
  const nextScale = Math.max(
    minScale,
    Math.min(maxScale, scale + (deltaY > 0 ? -step : step)),
  );
  const localX = cursorX / scale - translateX;
  const localY = cursorY / scale - translateY;

  return {
    scale: nextScale,
    translateX: cursorX / nextScale - localX,
    translateY: cursorY / nextScale - localY,
  };
};

export const calculateAnnotationPoint = ({
  viewportX,
  viewportY,
  scale,
  translateX,
  translateY,
  imageWidth,
  imageHeight,
}) => ({
  xPct: ((viewportX / scale - translateX) / imageWidth) * 100,
  yPct: ((viewportY / scale - translateY) / imageHeight) * 100,
});
